import Highcharts from 'highcharts';

import { InsightsChartSpec } from 'services/streamInsightsQuery';

import { baseInsightsOptions, valueAxis } from './shared';

// radar — a spider chart: the category axis wrapped into a circle, one closed
// line per metric. Matches the saved gadget, which forces every series to
// `line` on a polar pane and shows a legend only when there is more than one.
const buildPolarOptions = (spec: InsightsChartSpec): Highcharts.Options => {
  const base = baseInsightsOptions({
    spec,
    chartType: 'line',
    usePointName: false,
    showLegend: spec.series.length > 1,
  });

  return {
    ...base,
    chart: { ...base.chart, polar: true },
    series: spec.series.map((s) => ({
      type: 'line',
      name: s.name,
      data: s.data,
    })) as Highcharts.SeriesOptionsType[],
    xAxis: {
      categories: spec.categories,
      // Sit each category ON its spoke rather than between spokes, and close
      // the polygon back to the first category.
      tickmarkPlacement: 'on',
      lineWidth: 0,
    },
    yAxis: {
      ...valueAxis(spec),
      // Straight-edged web rings rather than circles — the convention for a
      // radar, and what the saved gadget draws.
      gridLineInterpolation: 'polygon',
      lineWidth: 0,
      min: 0,
    },
  };
};

export default buildPolarOptions;
